<template>
  <div class="content">
    <div class="box">
      <p class="chinese-name">便民专栏</p>
      <p class="english-name">SPECIAL</p>
      <div class="tab">
        <div v-for="item in list" :key="item" class="tab-box" :class="{ cursorDefault: !item.code && !item.contentCode }" @click="getDetail(item)" @mouseenter="changeTarget(item)" :style="
            target === item
              ? 'color: #000000; border-bottom: 1px solid rgba(203, 180, 134, 1);'
              : ''
          ">
          <span :title="item.title">{{ item.title }}</span>
        </div>
      </div>
      <div style="height: 0">
        <!-- v-show="['认证简介', '联系方式'].includes(target)" -->
        <div class="desc-content text-align" v-show="target.contentECount == 1 && target.moduleClass == 'announce'" v-html="showData"></div>
        <div class="desc-content" v-if="target.contentECount > 1 && target.moduleClass == 'announce'">
          <!-- v-show="target === '认证答疑'" -->
          <div>
            <p class="item-style" v-for="itemSub in showData" :key="itemSub.contentCode" @click="goDetail(itemSub)">
              <span class="ffcs" style="font-size: 16px">{{ itemSub.contentTitle }}</span>
            </p>
          </div>
        </div>
        <div class="desc-content" v-show="target.moduleClass == 'linkurl'">
          <!-- v-show="target === '便民检索'" -->
          <div>
            <p v-for="itemSub in showData" :key="itemSub.contentCode">
              <span style="font-size: 16px"><a class="cert-link" :href="itemSub.linkUrl" :title="'去往' + itemSub.linkUrl" target="_blank">{{ itemSub.linkTitle }}</a></span>
            </p>
          </div>

          <!-- <div v-for="(item, index) in data4" :key="item.contentCode">{{ index + 1 }}、<a class="cert-link" :href="item.linkUrl" :title="'去往'+item.linkUrl" target="_blank">{{ item.linkTitle }}</a></div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// const list = [
//   {
//     title: '认证简介',
//     contentCode: 'RESF066B8131D4CA82'
//   },
//   {
//     title: '认证答疑',
//     code: 'RES415CAEC37D7A196'
//   },
//   {
//     title: '便民检索',
//   },

//   // '联系方式'
// ]
import {
  getStep,
  getLinks,
  getList,
  getConsularTitle,
  getConsularDetails,
  getLink,
  getListData,
  getText
} from "@/api/consularCertification";
export default {
  name: "convenience-column",
  data () {
    return {
      list: [],
      target: "",
      data1: "",
      data2: "",
      data3: "",
      data4: [],
      showData: null,
    };
  },
  created () {
    console.log('2023-03-10 改');
    this.init();
  },
  methods: {
    goDetail (value) {
      const type = this.$route.query.type || "contentAnnounce";
      this.pushRouter(
        `/guide?contentCode=${value.contentCode}&type=${type}&linkname=领事认证/认证答疑/详情`
      );
    },
    getDetail (item) {
      if (item.code) {
        this.pushRouter(
          "/announcement?moduleCode=" +
          item.code +
          "&type=contentAnnounce&name=" +
          item.title
        );
      }
      if (item.contentCode) {
        getConsularDetails(item.contentCode).then((res) => {
          this.pushRouter(
            `/guide?contentCode=${res.data.records[0].contentCode}&type=contentAnnounce&linkname=${res.data.records[0].contentTitle}`
          );
        });
      }
    },
    changeTarget (item) {
      this.target = item;
      this.showData = null;
      if (item.title === "公证处检索") {
        getLink("RES12A08BAF96DF6D9").then((res) => {
          window.open(this._.get(res, "data.linkUrl"));
        });
      }
      this.list.forEach((e) => {
        if (
          e.title == item.title &&
          item.contentECount == 1 &&
          item.moduleClass == "announce"
        ) {
          this.getText(item.contentCode);
          return;
        }
        if (
          e.title == item.title &&
          item.contentECount > 1 &&
          item.moduleClass == "announce"
        ) {
          this.getListData(item.code);
          return;
        }
        if (e.title == item.title && item.moduleClass == "linkurl") {
          this.getLink(item.linkCode);
          return;
        }
      });
    },
    getText (code) {
      getConsularDetails(code).then((res) => {
        getStep(res.data.records[0].contentCode).then((result) => {
          this.showData = this.removeHtmlStyle(result.data.contentHtml) || null;
        });
      });
    },
    getListData (code) {
      getList(code).then((res) => {
        this.showData = res.data.records || null;
      });
    },
    getLink (code) {
      getLinks(code).then((res) => {
        this.showData = res.data.records || null;
      });
    },
    init () {
      // // 联系我们
      // getStep('RES6667B5CF324C0A5').then(res => {
      //   this.data2 = this._.get(res, 'data.contentHtml')
      // })
      // // 认证简介
      // getStep('RESF066B8131D4CA82').then(res => {
      //   this.data1 = this._.get(res, 'data.contentHtml')
      // })
      // getList('RES415CAEC37D7A196').then(res => {
      //   this.data3 = this._.get(res, 'data.records')
      //   console.log('data1',this.data3)
      // })
      // getLinks('RES6D87FF968FEAA13').then(res => {
      //   this.data4 = this._.get(res, 'data.records')

      // })
      getConsularTitle().then((res) => {
        if (res.data.records) {
          // console.log(res.data,'res,data')
          res.data.records.forEach((e) => {
            if (e.moduleClass === "linkurl") {
              this.list.push({
                title: e.moduleName,
                linkCode: e.moduleCode,
                contentECount: e.contentECount,
                moduleClass: e.moduleClass,
              });
            } else {
              if (e.contentECount == 1) {
                this.list.push({
                  title: e.moduleName,
                  contentCode: e.moduleCode,
                  contentECount: e.contentECount,
                  moduleClass: e.moduleClass,
                });
              } else {
                this.list.push({
                  title: e.moduleName,
                  code: e.moduleCode,
                  contentECount: e.contentECount,
                  moduleClass: e.moduleClass,
                });
              }
            }
          });
        }
        this.target = this.list[0] || "";
        this.changeTarget(this.target);
      });
    },
    removeHtmlStyle (html) {
      // console.log(html)
      // let rel = yle\s*?=\s*?([‘"])[\s\S]*?\1/g;
      let rel = /text-align.*?\;/;
      let newHtml = "";
      if (html) {
        newHtml = html.replace(rel, "");
      }
      // 清除类名
      // let relClass = /class\s*?=\s*?([‘"])[\s\S]*?\1/g;
      // let newClassHtml = "";
      // if (newHtml) {
      //   newClassHtml = newHtml.replace(relClass, "");
      // }
      return newHtml;
    },
  },
};
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  position: relative;
}
.box {
  width: 1140px;
  height: 500px;
  position: relative;
  margin: auto;
  // left: 50%;
  // transform: translateX(-50%);
  background: #fff;
}
.tab {
  font-size: 0px;
  padding-bottom: 35px;
  text-align: left;
  margin-top: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tab-box {
  display: inline-block;
  padding-bottom: 40px;
  height: 20px;
  cursor: pointer;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(188, 190, 192, 1);
  position: relative;
}
.tab-box:not(:last-of-type) {
  margin-right: 41px;
}
.chinese-name {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  position: relative;
  top: 20px;
}
.item-style {
  cursor: pointer;
  &:hover{
    color: rgb(203, 180, 134);
  }
}
.item-style:hover {
  color: rgb(203, 180, 134);
}
.ffcs:hover{
  color: rgb(203, 180, 134) !important;
}
.english-name {
  font-size: 80px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #faf5f5;
  position: absolute;
  z-index: -1;
  left: 50%;
  transform: translateX(-50%);
  top: -20px;
}
.desc-content {
  margin-top: -30px;
  p {
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 23px 0 23px 15px;
    position: relative;
    border-bottom: 1px solid RGBA(238, 238, 238, 1);
    span {
      font-size: 16px;
    }
    span:first-of-type {
      width: 80%;
      text-align: left;
    }
    span:last-of-type {
      color: rgb(25, 26, 26);
      font-size: 14px;
    }
    &:hover {
      color: rgba(203, 180, 134, 1);
    }
    img {
      width: 100% !important;
      height: 100% !important;
    }
  }
  p::before {
    content: "";
    display: inline-block;
    width: 5px;
    height: 5px;
    background: rgba(203, 180, 134, 1);
    border-radius: 50%;
    position: absolute;
    top: 32px;
    left: 0px;
  }
}
.cert-link {
  color: black;
}
.cert-link:hover {
  color: #cbb486;
}
.cursorDefault {
  cursor: default;
}
.text-align {
  text-align: justify !important;
  font-size: 14pt;
  text-indent: 38px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/consularCertification/siderContent-03.vue